import React from 'react';
import { Flex, Box, BoxProps } from '@chakra-ui/react';

import Sidebar from '../Sidebar';
import BrowserSupport from '#coreComponents/BrowserSupport';

export interface PrivateLayoutProps {
  sidebarWrapperProps?: BoxProps;
  contentWrapperProps?: BoxProps;
}

const PrivateLayout: React.FC<PrivateLayoutProps> = ({
  children,
  sidebarWrapperProps,
  contentWrapperProps,
}) => (
  <Flex>
    <Box
      position="fixed"
      left={0}
      height={{ base: 'initial', xl: '100vh' }}
      zIndex="docked"
      {...sidebarWrapperProps}
    >
      <Sidebar />
    </Box>
    <Box
      position="relative"
      w="100%"
      ml={{ lg: 250 }}
      maxWidth={{ lg: 'calc(100% - 250px)' }}
      mt={{ base: 128, lg: 68 }}
      px={{ base: 2, lg: 6 }}
      py={{ base: 4, lg: 6 }}
      {...contentWrapperProps}
    >
      <BrowserSupport />
      {children}
    </Box>
  </Flex>
);

export default PrivateLayout;
